var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulateDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.05666 5.80764C2.11472 5.74944 2.18369 5.70326 2.25962 5.67175C2.33555 5.64024 2.41696 5.62402 2.49916 5.62402C2.58137 5.62402 2.66277 5.64024 2.73871 5.67175C2.81464 5.70326 2.88361 5.74944 2.94166 5.80764L9.99916 12.8664L17.0567 5.80764C17.1148 5.74953 17.1838 5.70343 17.2597 5.67199C17.3356 5.64054 17.417 5.62435 17.4992 5.62435C17.5813 5.62435 17.6627 5.64054 17.7386 5.67199C17.8146 5.70343 17.8836 5.74953 17.9417 5.80764C17.9998 5.86575 18.0459 5.93474 18.0773 6.01066C18.1088 6.08659 18.125 6.16796 18.125 6.25014C18.125 6.33232 18.1088 6.4137 18.0773 6.48962C18.0459 6.56554 17.9998 6.63453 17.9417 6.69264L10.4417 14.1926C10.3836 14.2508 10.3146 14.297 10.2387 14.3285C10.1628 14.36 10.0814 14.3763 9.99916 14.3763C9.91696 14.3763 9.83555 14.36 9.75962 14.3285C9.68369 14.297 9.61472 14.2508 9.55666 14.1926L2.05666 6.69264C1.99846 6.63458 1.95228 6.56561 1.92077 6.48968C1.88927 6.41375 1.87305 6.33235 1.87305 6.25014C1.87305 6.16793 1.88927 6.08653 1.92077 6.0106C1.95228 5.93467 1.99846 5.8657 2.05666 5.80764Z",
    fill: "#8D9AB4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulateDropdown);
export default __webpack_public_path__ + "static/media/simulate-dropdown.e8b7047ef1fa71253b442ea04b8018a9.svg";
export { ForwardRef as ReactComponent };